"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const numbersMatch = {
  canada: number => number.match(/(\d{3})(\d{3})(\d{4})$/),
  franceWithCode: number => number.match(/(\d{1})(\d{2})(\d{2})(\d{2})(\d{2})$/),
  franceWithoutCode: number => number.match(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/)
};
function outputFormat(number) {
  const str = String(number);
  const withIntlCode = str.match(/^\+1/g);

  // remove all unnecessary caracters and return only the numbers
  // eslint-disable-next-line no-useless-escape
  const getOnlyNumbers = str.replace(/[^\d]/g, '');
  // remove all unnecessary caracters and return only numbers and '+' symbol
  const numbers = str.replace(/[^\d\+]/g, '');
  const codeOrPrefix = numbers.match(/^(\+1|001|\+33|0033)/);
  const intlCode = codeOrPrefix && codeOrPrefix[1] ? codeOrPrefix[1] : undefined;
  if (withIntlCode && getOnlyNumbers.length === 11 || !withIntlCode && getOnlyNumbers.length === 10) {
    if (codeOrPrefix) {
      if (codeOrPrefix[1] === '+1' || codeOrPrefix[1] === '001') {
        const phoneMatch = numbersMatch.canada(numbers);
        return {
          number: "(" + phoneMatch[1] + ") " + phoneMatch[2] + "-" + phoneMatch[3],
          countryCode: intlCode
        };
      }
      if (codeOrPrefix[1] === '+33' || codeOrPrefix[1] === '0033') {
        const phoneMatch = numbersMatch.franceWithCode(numbers);
        return {
          number: "0" + phoneMatch[1] + " " + phoneMatch[2] + "-" + phoneMatch[3] + "-" + phoneMatch[4] + "-" + phoneMatch[5],
          countryCode: intlCode
        };
      }
    } else if (numbers[0] === '0') {
      const phoneMatch = numbersMatch.franceWithoutCode(numbers);
      return {
        number: phoneMatch[1] + " " + phoneMatch[2] + " " + phoneMatch[3] + " " + phoneMatch[4] + " " + phoneMatch[5],
        countryCode: intlCode
      };
    } else {
      const phoneMatch = numbersMatch.canada(numbers);
      return {
        number: "(" + phoneMatch[1] + ") " + phoneMatch[2] + "-" + phoneMatch[3],
        countryCode: intlCode
      };
    }
  } else {
    return undefined;
  }
}

/**
 * The phone output component is used to display the number phone.
 */

const PhoneOutput = props => {
  const {
    value,
    className,
    countryCode,
    displayAsText,
    ...attributes
  } = props;
  const [output, setOutput] = _react.default.useState({});
  _react.default.useEffect(() => {
    if (value) {
      setOutput(outputFormat(value));
    } else {
      setOutput();
    }
  }, [value]);
  const classes = (0, _clsx.default)('uk-phone-output', className);
  if (displayAsText || !value) {
    return output != null && output.number ? /*#__PURE__*/_react.default.createElement("span", _extends({
      className: classes
    }, attributes), output.countryCode ? output.countryCode + " " + output.number : countryCode ? countryCode + " " + output.number : "" + output.number) : /*#__PURE__*/_react.default.createElement("span", {
      className: "uk-phone-output uk-phone-output--unformatted"
    }, value);
  }
  return output ? /*#__PURE__*/_react.default.createElement("a", _extends({
    className: classes,
    href: "tel:" + (output != null && output.countryCode ? output == null ? void 0 : output.countryCode : '') + (output == null ? void 0 : output.number)
  }, attributes), output.countryCode ? output.countryCode + " " + output.number : countryCode ? countryCode + " " + output.number : "" + output.number) : /*#__PURE__*/_react.default.createElement("span", {
    className: "uk-phone-output uk-phone-output--unformatted"
  }, value);
};
PhoneOutput.propTypes = {
  /**
   * Take any phone numbers
   */
  value: _propTypes.default.any.isRequired,
  /**
   * Display country code
   */
  countryCode: _propTypes.default.oneOf(['', '+1', '+33']),
  /**
   * Display country code
   */
  displayAsText: _propTypes.default.bool
};
PhoneOutput.defaultProps = {
  value: '000 000 0000',
  countryCode: '+1',
  displayAsText: false
};
var _default = exports.default = PhoneOutput;